/**
 * 常量
 */
let constant = {
  // 在此处添加之后需要在order下的search()方法修改添加
  wxSubjectList: {
    '收款主体': '',
    '总公司-2021002115688226': '2021002115688226',
    '分公司-2019022863445525': '2019022863445525',
    '瞬马-2021001167668213': '2021001167668213',
    '广州白马电子商务股份有限公司-1508850841': 'wx1508850841',
    '广州市云兰霞衣科技有限公司-1605058271': 'wx1605058271',
    '广州市云兰霞衣科技有限公司-1605156200': 'wx1605156200',
    '其他': '-1'
  },
  apkList: {
    // '1-百变魔术相机': 1,
    '2-美颜证件照相机': 2,
    '3-最美证件照': 3,
    '4-PC证件照': 4,
    '5-微信小程序证件照': 5,
    '6-智能证件照': 6
  },
  orderTypeList: {
    '证件照拍摄 - 无正装': 0,
    '证件照拍摄 - 加正装': 1,
    '一键换背景': 2,
    '裁剪证件照': 3,
    '修改文件大小': 4,
    '月会员': 5
  },
  phoneOsList: {
    '安卓': 0,
    'IOS': 1,
    'PC': 2,
    'Web': 3,
    '微信小程序': 4
  },
  apkChannelList: {
    '市场渠道': 1,
    '小程序渠道': 2,
    '品牌渠道': 3,
    'seo渠道': 4,
    '推广渠道': 5,
    '信息流渠道': 7,
    'Dev渠道': 8,
  },
  /**
   * 商户号投诉类型
   */
  handleTypeMap: {
    '无恢复效果': '无恢复效果',
    '联系超时': '联系超时',
    '退款问题': '退款问题',
    '不需要恢复': '不需要恢复',
    '无法正常使用': '无法正常使用',
    '已操作，无所需数据': '已操作，无所需数据',
    '不会操作': '不会操作',
    '投诉建议': '投诉建议',
    '二次付费': '二次付费',
    '非本机恢复': '非本机恢复',
    '缺少电脑': '缺少电脑',
    '描述不符': '描述不符',
    '客户主观原因': '客户主观原因',
    '错误购买': '错误购买',
    '业务不支持': '业务不支持',
    '重复购买': '重复购买',
    '自主找回': '自主找回',
    '未操作，恢复概率低': '未操作，恢复概率低',
    '已发短信，无添加': '已发短信，无添加',
    '无法联系客户': '无法联系客户',
    '恢复图片不清晰': '恢复图片不清晰',
    '其他': '其他'
  },
  mSpecIds: {
    "1": "一寸",
    "2": "一寸",
    "3": "一寸",
    "4": "小一寸",
    "5": "小一寸",
    "6": "小一寸",
    "7": "大一寸",
    "8": "大一寸",
    "9": "大一寸",
    "10": "二寸",
    "11": "二寸",
    "12": "二寸",
    "13": "小二寸",
    "14": "小二寸",
    "15": "小二寸",
    "16": "三寸",
    "17": "三寸",
    "18": "三寸",
    "19": "五寸",
    "20": "五寸",
    "21": "五寸",
    "22": "国考（二寸）",
    "23": "英语四六级考试（144×192，0~10kb）",
    "24": "英语四六级考试（240×320，20~30kb）",
    "25": "普通话水平测试（大一寸，0~20kb）",
    "26": "英语四六级考试（240×320，0~20kb）",
    "27": "全国计算机等级考试（大一寸，144×192，25~200kb）",
    "28": "中国护照（大一寸）",
    "29": "全国计算机等级考试（240×320）",
    "30": "高考报名（545×763）",
    "31": "中小学生教师资格证（一寸）",
    "32": "全国计算机等级考试（240×320）",
    "33": "小学登记报名",
    "34": "国家司法考试",
    "35": "国考（100×140）",
    "36": "初级会计职称考试（240×320）",
    "37": "全国计算机等级考试（大一寸，144×192，50~200kb）",
    "38": "国考（99×128）",
    "39": "国考（北京）",
    "40": "国考（天津）",
    "41": "国考（河北）",
    "42": "国考（山西）",
    "43": "国考（内蒙古）",
    "44": "国考（辽宁）",
    "45": "国考（吉林）",
    "46": "国考（黑龙江）",
    "47": "国考（上海）",
    "48": "国考（江苏）",
    "49": "国考（浙江）",
    "50": "国考（安徽）",
    "51": "国考（福建）",
    "52": "国考（江西）",
    "53": "国考（山东）",
    "54": "国考（河南）",
    "55": "国考（湖北）",
    "56": "国考（湖南）",
    "57": "国考（广东）",
    "58": "国考（广西）",
    "59": "国考（海南）",
    "60": "国考（重庆）",
    "61": "国考（四川）",
    "62": "国考（贵州）",
    "63": "国考（云南）",
    "64": "国考（陕西）",
    "65": "国考（甘肃）",
    "66": "国考（青海）",
    "67": "国考（宁夏）",
    "68": "国考（新疆）",
    "69": "国考（西藏）",
    "70": "台湾通行证（大一寸，无回执）",
    "71": "港澳通行证（大一寸，无回执）",
    "72": "初级会计职称考试（114×156）",
    "73": "徐州公务员（二寸）",
    "74": "中级会计职称考试（一寸）",
    "75": "北京全国计算机等级考试",
    "76": "全国高等教育自学考试",
    "77": "护士执业资格考试（160×210）",
    "78": "天津公务员（小二寸）",
    "79": "河北省选调生（小二寸）",
    "80": "全国职称计算机考试",
    "81": "河北公务员",
    "82": "山西公务员（小二寸）",
    "83": "内蒙古公务员（小二寸）",
    "84": "辽宁公务员（二寸）",
    "85": "吉林公务员（二寸）",
    "86": "黑龙江公务员（小二寸）",
    "87": "上海公务员",
    "88": "江苏公务员（小二寸）",
    "90": "安徽公务员（二寸）",
    "91": "安徽公务员（一寸）",
    "92": "福建公务员（二寸）",
    "93": "江西公务员（90×120）",
    "94": "山东公务员（小二寸）",
    "95": "河南公务员",
    "96": "湖北公务员",
    "97": "湖南公务员（小二寸）",
    "98": "湖南公务员（一寸）",
    "99": "广东公务员（二寸）",
    "100": "广州公务员（二寸）",
    "101": "广西公务员（二寸）",
    "102": "海南公务员",
    "103": "海南公务员（二寸）",
    "104": "重庆公务员（小二寸）",
    "105": "四川公务员（二寸）",
    "106": "贵州公务员（二寸）",
    "107": "云南公务员（小二寸）",
    "108": "西藏公务员（一寸）",
    "109": "陕西公务员（二寸）",
    "110": "甘肃公务员（小二寸）",
    "111": "青海公务员",
    "112": "宁夏公务员（小二寸）",
    "113": "新疆公务员（小二寸）",
    "114": "泰国签证（二寸）",
    "115": "泰国签证",
    "116": "韩国签证（二寸）",
    "117": "日本签证（小二寸）",
    "118": "日本签证",
    "119": "美国签证（用于纸质冲印）",
    "120": "越南签证（小二寸）",
    "121": "法国签证（小二寸）",
    "122": "澳大利亚签证（小二寸）",
    "123": "柬埔寨签证（小二寸）",
    "124": "德国签证（小二寸）",
    "125": "加拿大签证（小二寸）",
    "126": "加拿大签证（小二寸，413×531px）",
    "127": "希腊签证（小二寸）",
    "128": "英国签证（小二寸）",
    "129": "西班牙签证（小二寸）",
    "130": "瑞士签证（小二寸）",
    "131": "新西兰签证（小二寸）",
    "132": "南非签证（小二寸）",
    "133": "尼泊尔签证（二寸）",
    "134": "老挝签证（小二寸）",
    "135": "缅甸签证",
    "136": "意大利签证",
    "137": "意大利签证（小二寸）",
    "138": "俄罗斯签证（小二寸）",
    "139": "荷兰签证（小二寸）",
    "140": "阿联酋签证（小二寸）",
    "141": "印度签证（二英寸）",
    "142": "奥地利签证（小二寸）",
    "143": "比利时签证（小二寸）",
    "144": "巴西签证（小二寸）",
    "145": "埃及签证（小二寸）",
    "146": "孟加拉签证（二寸）",
    "147": "马尔代夫签证（小二寸）",
    "148": "葡萄牙签证（小二寸）",
    "149": "瑞典签证（小二寸）",
    "150": "阿根廷签证",
    "151": "蒙古签证（小二寸）",
    "152": "丹麦签证（小二寸）",
    "153": "芬兰签证（小二寸）",
    "154": "爱尔兰签证（小二寸）",
    "155": "挪威签证（小二寸）",
    "156": "匈牙利签证（小二寸）",
    "157": "新加坡签证",
    "158": "新加坡签证（小二寸）",
    "159": "执业医师资格证（小二寸）",
    "160": "菲律宾签证（小二寸）",
    "161": "马来西亚电子签",
    "162": "马来西亚签证",
    "163": "印度尼西亚签证（小二寸）",
    "164": "墨西哥签证（小二寸）",
    "165": "乌克兰签证（小二寸）",
    "166": "波兰签证（小二寸）",
    "167": "智利签证（小二寸）",
    "168": "文莱签证（小二寸）",
    "169": "马达加斯加签证（小二寸）",
    "170": "沙特阿拉伯签证（小二寸）",
    "171": "赞比亚签证（小二寸）",
    "172": "克罗地亚签证（小二寸）",
    "173": "执法证冲印版",
    "174": "肯尼亚签证",
    "175": "罗马尼亚签证（小二寸）",
    "176": "乌兹别克斯坦签证（小二寸）",
    "177": "哈萨克斯坦签证（小二寸）",
    "178": "巴基斯坦签证（小二寸）",
    "179": "纳米比亚签证（小二寸）",
    "180": "社保证（300dpi， 无回执）",
    "181": "尼日利亚签证（小二寸）",
    "182": "巴林签证（小二寸）",
    "183": "驾驶证、驾照（无回执，小一寸）",
    "184": "身份证（无回执）",
    "185": "康复治疗师考试（一寸）",
    "186": "古巴签证（小二寸）",
    "187": "健康证（一寸）",
    "188": "英语四六级考试（150×200，0~25kb）",
    "189": "深圳行政执法证",
    "190": "中高级口译",
    "191": "社会工作者资格证（一寸）",
    "192": "英语四六级考试（150×200，30~100kb）",
    "194": "二级建造师证（215×300）",
    "195": "英语四六级考试（144×172，0~40kb）",
    "196": "成人自考（400×576）",
    "197": "普通话水平测试（144×192）",
    "198": "捷克签证（小二寸）",
    "199": "英语四六级考试（76×101）",
    "200": "斯洛伐克签证（小二寸）",
    "201": "以色列签证（二英寸）",
    "202": "二级建造师证（100×140）",
    "203": "河南行政执法证",
    "204": "广东行政执法证",
    "205": "伊朗签证（小二寸）",
    "206": "卡塔尔签证（小二寸）",
    "207": "江西行政执法证",
    "208": "陕西行政执法证（一寸）",
    "209": "工商银行网申（100×140）",
    "210": "会计从业资格证（114×156，0~15kb）",
    "211": "四川行政执法证（小二寸）",
    "212": "浙江行政执法证（一寸）",
    "213": "中级会计职称考试（240×320）",
    "214": "河北行政执法证（小二寸）",
    "215": "交通银行网申（一寸）",
    "216": "雅思考试（大一寸）",
    "217": "商务英语考试",
    "218": "全国林业执法证（大二寸）",
    "219": "建设银行网申",
    "220": "高级会计职称考试",
    "221": "一寸工作证",
    "222": "辽宁林业执法证（小二寸）",
    "223": "职称英语考试（一寸）",
    "224": "高考报名（480×640）",
    "225": "江西安全监管执法证（一寸）",
    "226": "社保证（350dpi， 无回执，15~35kb）",
    "227": "在职研究生考试（大一寸）",
    "228": "二寸工作证",
    "229": "导游证",
    "230": "三支一扶",
    "231": "全民健身操舞（二寸）",
    "232": "山东导游证",
    "233": "中国签证（大一寸）",
    "234": "北京导游证（小二寸）",
    "235": "计算机二级考试（210×280）",
    "236": "翻译资格等级考试",
    "237": "四川执业药师注册工作照（二寸）",
    "238": "大学个人档案（二寸）",
    "239": "江西中医药大学医保卡",
    "240": "校园卡采集",
    "241": "校园卡",
    "242": "香港城市大学入学报名",
    "243": "湖北经济学院校园卡",
    "244": "北京师范大学入学报名",
    "245": "特岗教师",
    "246": "中国农业大学入学报名",
    "247": "中南财经政法大学入学报名",
    "248": "西班牙商务签证（小二寸）",
    "249": "闽南师范大学",
    "250": "英语四六级考试（大一寸，20~200kb）",
    "251": "上海学籍卡",
    "252": "学位英语",
    "253": "中华人民共和国外国人工作许可（二寸）",
    "254": "学籍网",
    "255": "学籍照片（390×480）",
    "256": "英语四六级考试（大一寸0~20kb）",
    "257": "湖北会计职业资格证",
    "258": "中国人民银行网申",
    "259": "广州羊城通学生乘车卡（大一寸）",
    "260": "普通话水平测试（大一寸，30~80kb）",
    "261": "英语四六级考试（144×192，10~20kb）",
    "262": "英语四六级报名",
    "263": "保健按摩师",
    "264": "营养配餐员",
    "265": "中药调剂员",
    "266": "护士执业资格考试（130×170）",
    "267": "会计从业资格证（114×156，0~10kb）",
    "268": "摄影师",
    "269": "学籍照片（307×378）",
    "270": "厦门大学毕业证",
    "271": "反假证（一寸）",
    "272": "深圳会计从业资格证",
    "273": "英语四六级考试（150×210，0~40kb）",
    "274": "云南师范大学文理学院",
    "275": "工商银行网申（240×370）",
    "276": "青岛浮山路小学学籍卡",
    "277": "二寸工作证",
    "278": "英语四六级考试（480×600）",
    "279": "教师资格证（180×240）",
    "280": " 执业兽医资格证",
    "281": "广东岭南职业技术学院学籍卡",
    "282": "医保证（300dpi）",
    "283": "高考报名（一寸）",
    "284": "越南签证",
    "285": "中国教师资格证报名",
    "286": "工商银行网申生活照",
    "288": "中国移动网上报名",
    "289": "武汉大学研究生考试",
    "290": "英语三级考试",
    "291": "英语四六级考试（144×192，8~10kb）",
    "292": "医护英语",
    "293": "职业鉴定照片",
    "294": "香港学生国内报名",
    "295": "上海中考网报名",
    "296": "硕士研究生考试（大一寸）",
    "297": "福建教师资格证",
    "298": "江苏会计考试",
    "299": "成都人事考试网",
    "300": "网申国企",
    "301": "墨西哥签证（非营利性访客签证）",
    "302": "大数据工程师报名",
    "304": "甘肃民族师范学院学籍卡（二寸）",
    "305": "运城市临猗事业单位报名",
    "306": "北大考研网上报名",
    "308": "苏州科技大学研究生报名",
    "309": "厦门医保卡",
    "310": "川北医学院自考本科",
    "311": "广西贺州高考报名",
    "312": "黑龙江会计上岗证",
    "313": "计算机考试（350dpi）",
    "314": "河北唐山初级会计助理",
    "315": "深圳社保证（小于20KB， 无回执）",
    "316": "国家公务员（小二寸）",
    "317": "云南公务员（二寸）",
    "318": "江西公务员（99×128）",
    "319": "计算机三级",
    "320": "广西钦州高考报名",
    "321": "北京地区中央机构报名（小二寸）",
    "322": "华师大MBA报名",
    "323": "西安美术联考（一寸）",
    "324": "大学生图像信息采集",
    "325": "北京公务员",
    "326": "入台证（小二寸）",
    "327": "全国教师管理信息采集（129×160）",
    "328": "山西省全国计算机等级考试（一寸）",
    "329": "大学生信息采集",
    "330": "制图员（大一寸，350dpi）",
    "331": "全国教师管理信息采集（296×367）",
    "332": "北京党员代表大会（二寸）",
    "333": "学校自考",
    "334": "北京教师信息网",
    "335": "宁夏回族自治区专业技术人员（一寸）",
    "336": "亳州人民医院报考2017",
    "337": "教师资格证（150×200）",
    "338": "医保证（350dpi）",
    "339": "大学生入党统计表（天津商业大学）",
    "340": "会计征换证",
    "341": "重庆选调生",
    "342": "金蝶认证",
    "343": "警官证",
    "344": "计算机中级操作员（ATA）",
    "345": "护士资格证考试（小二寸）",
    "346": "微信头像",
    "347": "江西国画书法等级考试",
    "348": "宁波外语口译考试（大一寸）",
    "349": "二级建造师（160×180）",
    "350": "教师资格证（384×512）",
    "351": "甘肃计算机等级考试",
    "352": "全国计算机等级考试（大一寸，390×567）",
    "353": "辽宁二级建造证（一寸）",
    "354": "教师招聘报名",
    "355": "执业医师资格报名（小二寸）",
    "356": "成都公务员",
    "358": "一级建造师证（电子版）",
    "359": "一级建造师证（冲印版）",
    "360": "公共英语考试（二寸）",
    "361": "个别奖学金申请",
    "362": "江苏社保卡（无回执，358×441）",
    "363": "六级口语考试",
    "364": "学士学位报考",
    "365": "成人自考（360×480）",
    "366": "小学新生学籍",
    "367": "二级建造师证（电子版）",
    "368": "学籍照片（150×200）",
    "369": "党员证",
    "370": "教师资格证（360×480）",
    "371": "特殊招聘要求",
    "372": "秘书证",
    "373": "香港特別行政區護照",
    "374": "高速公路管理局 ",
    "375": "养老护理员（二寸）",
    "376": "学信网",
    "377": "金融服务师",
    "378": "合肥人事网招聘（二寸）",
    "379": "全国计算机等级考试（150×210）",
    "380": "医疗（二寸）",
    "381": "团员证（一寸）",
    "382": "医疗类报名（一寸）",
    "383": "计算机等级考试（小二寸）",
    "385": "一卡通",
    "386": "会计从业资格证（150×200）",
    "387": "会计从业资格证（150×210）",
    "388": "中国人民银行网申（0~20kb）",
    "389": "新生网站登记",
    "390": "高中毕业证",
    "391": "简历照片（一寸）",
    "392": "专升本考试",
    "393": "陕西二级建造师证（小于100kb）",
    "394": "工作卡",
    "395": "江苏社保卡（无回执 252×312）",
    "396": "育婴师考试报名（二寸）",
    "397": "单招",
    "398": "社保证（无回执）",
    "399": "英语AB级考试",
    "400": "高考报名（420×560）",
    "401": "普通话水平测试（144×172）",
    "402": "托业考试",
    "403": "自主招生考试",
    "404": "METS医护英语水平考试（二寸）",
    "405": "注册会计师证（178×220）",
    "406": "计算机文化考试",
    "407": "人力资源资格证报名",
    "408": "执业医师注册",
    "409": "事业单位招聘",
    "410": "普通话水平测试（大一寸 150~300kb）",
    "411": "SAT考试报名（电子版）",
    "412": "全国医用设备使用人员业务能力考评（一寸）",
    "413": "入学报名（一寸）",
    "414": "农业银行网申（一寸）",
    "415": "高考报名（192×256）",
    "416": "会计从业资格证（97×130）",
    "417": "工作卡（637×672px）",
    "418": "营销师考试报名",
    "419": "成人自考（一寸）",
    "420": "执业药师资格考试（一寸）",
    "421": "执业药师资格考试（二寸）",
    "422": "大学入学报名（小二寸）",
    "423": "复旦大学研究生考试",
    "424": "注册会计师证（102×126）",
    "425": "出入境申请表",
    "426": "微商注册",
    "427": "计算机二级考试（300×400）",
    "428": "全国房地产经济从业职业资格证",
    "429": "二级建造师（160×200）",
    "430": "社保证（350dpi， 无回执，30~60kb）",
    "431": "英语应用能力考试口试",
    "432": "注册会计师考试（一寸）",
    "433": "注册计量师考试",
    "434": "电子护照人像照片",
    "435": "海外申请护照在线预约照片",
    "436": "毕业证照片采集（西安交大）",
    "437": "网约车照片（小二寸）",
    "438": "深圳社保证（大于140KB， 无回执）",
    "439": "600×840",
    "440": "电子导游证（二寸）",
    "441": "党员证（红底）",
    "442": "1051×1500px",
    "443": "河南理工大学校园卡电子照",
    "444": "湖南社保卡",
    "445": "大学报名电子照",
    "446": "重庆西南大学自考",
    "447": "重庆公务员",
    "448": "四川自考",
    "449": "上海自考",
    "450": "北京自考",
    "451": "河北自考",
    "452": "新疆自考",
    "453": "安徽自考",
    "454": "江苏社保卡",
    "455": "深圳社保证",
    "456": "湖北社保证",
    "457": "江西社保证",
    "458": "二寸",
    "459": "小二寸",
    "460": "300×380px",
    "461": "长春医保卡",
    "462": "成人学士学位外语水平联考",
    "463": "上海电子学生证",
    "464": "电子医生注册",
    "465": "小二寸（32×40mm）",
    "466": "学籍照片（90×120）",
    "468": "会计资格证照片",
    "469": "毕业证照片采集（西南科技大学、西南大学）",
    "470": "公务员考试",
    "471": "护士电子化注册",
    "472": "毕业生图像信息采集",
    "473": "护士执业资格考试（120×160）",
    "474": "护士执业资格考试（一寸）",
    "475": "168×240",
    "476": "一寸半身照",
    "477": "二寸半身照",
    "478": "人民警察证",
    "479": "山东自考",
    "480": "护师（全国卫生专业技术资格考试）",
    "481": "初级护师（一寸）",
    "482": "主管护师（一寸）",
    "483": "初级护师（小二寸）",
    "484": "主管护师（小二寸）",
    "485": "甘肃社保证",
    "486": "主管护师（160×210）",
    "487": "山西省社会保障卡照片",
    "488": "渐变蓝底",
    "489": "监理工程师（150×210）",
    "490": "监理工程师（215×300）",
    "491": "广州市考",
    "492": "福建自考",
    "493": "二级建造师证（295×413）",
    "494": "江西吉安公务员照片采集",
    "495": "陕西省二级建造师（180~300kb）",
    "496": "学位英语（390*567）",
    "497": "上海中级会计职称考试",
    "498": "福建教师招聘考试",
    "499": "莱芜职业技术学院学籍照",
    "500": "中级会计职称考试（114×156）",
    "501": "二级建造师证（220×300）",
    "502": "突尼斯签证",
    "503": "马耳他签证",
    "504": "斯里兰卡签证",
    "505": "格鲁吉亚签证",
    "506": "冰岛签证",
    "507": "立陶宛签证",
    "508": "马里签证",
    "509": "吉尔吉斯斯坦签证",
    "510": "喀麦隆签证",
    "511": "新西兰签证（小二寸）",
    "512": "阿根廷签证（小二寸）",
    "513": "巴西签证",
    "514": "湖北省中小学毕业证照片采集",
    "515": "国企单位存档",
    "516": "相片采集照",
    "517": "软考",
    "518": "签证采集",
    "519": "上海专升本",
    "520": "单位照片",
    "521": "幼升小报名",
    "522": "滕州市社保照",
    "523": "江西特岗教师考试",
    "524": "江西国编教师考试",
    "525": "记者照片",
    "526": "四寸",
    "527": "义工证",
    "528": "网约车运营证",
    "529": "特岗教师",
    "530": "主治医师",
    "531": "山西省社保照",
    "532": "香港特別行政區護照",
    "533": "全国英语等级考试",
    "534": "全国公共英语考试",
    "535": "三支一扶（一寸，大于30kb）",
    "536": "毕业生图像信息采集（20~40kb）",
    "537": "河南社保照",
    "538": "研究生（27×36mm）",
    "539": "入学照（一寸）",
    "540": "入学照（小二寸）",
    "541": "日本签证（二寸）上海&成都",
    "542": "日本签证上海&北京&广州",
    "543": "越南签证（二寸）",
    "544": "法国签证（二寸）",
    "545": "澳大利亚签证（二寸）",
    "546": "柬埔寨签证（二寸）",
    "547": "德国签证（二寸）",
    "548": "希腊签证（二寸）",
    "549": "英国签证（二寸）",
    "550": "西班牙签证（二寸）",
    "551": "瑞士签证（二寸）",
    "552": "缅甸签证（上海广州成都）",
    "553": "缅甸签证(北京)",
    "554": "意大利签证上海北京",
    "555": "意大利签证（二寸）成都广州",
    "556": "俄罗斯签证（二寸）",
    "557": "荷兰签证（二寸）",
    "558": "奥地利签证（二寸）",
    "559": "巴西签证",
    "560": "葡萄牙签证（二寸）",
    "561": "瑞典签证（二寸）",
    "562": "丹麦签证（二寸）",
    "563": "芬兰签证（二寸）",
    "564": "挪威签证（小二寸）上海&广州",
    "565": "挪威签证（小二寸）北京",
    "566": "匈牙利签证（二寸）",
    "567": "新加坡签证（二寸）",
    "568": "菲律宾签证（二寸）",
    "569": "马来西亚签证上海&广州",
    "570": "马来西亚签证成都&北京",
    "571": "墨西哥签证北京",
    "572": "波兰签证（二寸）",
    "573": "肯尼亚签证北京",
    "574": "捷克签证（二寸）",
    "575": "以色列签证（二英寸）上海广州",
    "576": "以色列签证（二英寸）成都北京",
    "577": "入台证（大一寸）",
    "578": "冰岛签证北京",
    "579": "冰岛签证上海广州",
    "580": "新西兰签证成都",
    "581": "新西兰签证上海广州北京",
    "582": "黎巴嫩",
    "583": "约旦",
    "584": "阿曼",
    "585": "伊拉克",
    "586": "土库曼斯坦",
    "587": "亚美尼亚",
    "588": "阿富汗",
    "589": "也门",
    "590": "叙利亚",
    "591": "巴布亚新几内亚",
    "592": "坦桑尼亚",
    "593": "加纳",
    "594": "利比亚",
    "595": "阿尔及利亚",
    "596": "多哥",
    "597": "刚果（金）",
    "598": "莫桑比克",
    "599": "津巴布韦",
    "600": "科特迪瓦",
    "601": "刚果共和国",
    "602": "塞拉利昂",
    "603": "布隆迪",
    "604": "博茨瓦纳",
    "605": "塞内加尔",
    "606": "索马里",
    "607": "厄立特里亚",
    "608": "布基纳法索",
    "609": "吉布提",
    "610": "贝宁",
    "611": "马拉维",
    "612": "卢旺达",
    "613": "乍得",
    "614": "几内亚",
    "615": "冈比亚",
    "616": "尼日尔",
    "617": "利比里亚",
    "618": "莱索托",
    "619": "中非",
    "620": "佛得角",
    "621": "几内亚比绍",
    "622": "北苏丹",
    "623": "埃塞俄比亚",
    "624": "赤道几内亚",
    "625": "安哥拉",
    "626": "马其顿签证",
    "627": "亚美尼亚签证",
    "628": "摩尔多瓦签证",
    "629": "白俄罗斯签证",
    "630": "保加利亚签证",
    "631": "泰安社保卡（无回执）",
    "632": "英语AB级（一寸）",
    "633": "英语AB级（小一寸）",
    "634": "贵州社保卡",
    "635": "出入境证件",
    "636": "身份证证件照",
    "637": "杭州社保证",
    "638": "阿塞拜疆签证",
    "639": "塞浦路斯签证",
    "640": "大溪地签证",
    "641": "摩纳哥签证",
    "642": "爱沙尼亚签证",
    "643": "拉脱维亚签证",
    "644": "斯洛文尼亚签证",
    "645": "阿尔巴尼亚签证",
    "646": "秘鲁签证",
    "647": "哥伦比亚签证",
    "648": "乌拉圭签证",
    "649": "特立尼达和多巴哥签证",
    "650": "哥斯达黎加签证",
    "651": "圭亚那签证",
    "652": "苏里南签证",
    "653": "乌干达签证",
    "654": "南苏丹签证",
    "655": "居住证",
    "656": "法国签证(柏思睿)",
    "657": "实名证件照",
    "658": "贵州人和一寸正面免冠",
    "659": "美国护照照片",
    "660": "二代身份证照",
    "661": "上海义务教育入学",
    "662": "毕业生图像信息采集（413*626）",
    "663": "入学图像信息采集(416*605)",
    "664": "入学定制图像信息采集(306*378)",
    "665": "湖南老年人优待证",
    "666": "湖南生育证",
    "667": "湖南流动人口婚育证",
    "668": "湖南离婚证",
    "669": "湖南二级建造师",
    "670": "湖南一级建造师",
    "671": "湖南导游证",
    "672": "湖南教师资格证",
    "673": "湖南研究生考试",
    "674": "保险从业",
    "675": "全国中小学生学籍",
    "676": "大二寸",
    "677": "大二寸",
    "678": "大二寸",
    "679": "国家医学考试",
    "680": "反假币考试",
    "681": "南京友博学生照",
    "682": "普通话水平考试",
    "683": "英语四六级考试（144×192，20~100kb）",
    "684": "英语四六级考试（295×413，0~20kb）",
    "685": "初级会计职称考试（295×413）",
    "686": "中级会计职称考试（295×413）",
    "687": "2021注册会计师证",
    "688": "大学生图像信息采集",
    "689": "简历照片(一寸",
    "690": "团员证（254x372）"
  },
  adPositionList: {
    '解锁功能全屏视频': 'unlockFullScreenVideo',
    '拍摄返回插屏': 'shootReturnIntercutting',
    '解锁效果激励视频': 'unlockEffectIncentiveVideo',
    '结果页信息流': 'resultPageInfoFlow',
    '开屏广告': 'openAd',
    '结果返回全屏视频': 'resultFullScreenVideo',
    '个人中心信息流': 'personalInfoFlow',
  },
  /**
   * 退款类型，14以下为新增
   */
  refundTypeMap: {
    '0': '不需要恢复',
    '1': '缺少电脑',
    '2': '已操作，无所需数据',
    '3': '其他',
    '4': '错误购买',
    '5': '业务不支持',
    '6': '重复购买',
    '7': '二次付费',
    '8': '联系超时',
    '9': '投诉建议',
    '10': '自主找回',
    '11': '非本机恢复',
    '12': '未操作，恢复概率低',
    '13': '无法正常使用',
    '14': '商户号投诉',
    '15': '客户主观原因',
    '16': '已发短信，无添加',
    '17': '无法联系客户',
    '18': '不会操作',
    '19': '描述不符',
    '20': '已操作，无数据',
    '21': '恢复图片不清晰'
  },
  subRefundTypeMap: {
    '14': {},
  },
  roleGroup: {
    admin: ['admin'],
    pe: ['pe'], // 工程师普通(有旧业务需要适配)
    pe_manager: ['pe_gl', 'pe_m'],
    kf: ['kf'], // 客服普通(有旧业务需要适配)
    kf_manager: ['kf_gl', 'kf_m']
  },
  roleList: [
    {
      id: '',
      name: '全部角色'
    },
    {
      id: 'admin',
      name: '管理员'
    },
    // {
    //   id: 'after_sale',
    //   name: '售后'
    // },
    // {
    //   id: 'brand_sale',
    //   name: '品牌营销'
    // },
    // {
    //   id: 'sem',
    //   name: 'sem'
    // },
    // {
    //   id: 'seo',
    //   name: 'seo'
    // },
    // {
    //   id: 'finance',
    //   name: '财务'
    // },
    {
      id: 'kf',
      name: '客服'
    },
    // {
    //   id: 'kf_gl',
    //   name: '客服组长'
    // },
    // {
    //   id: 'kf_m',
    //   name: '客服主管'
    // },
    // {
    //   id: 'pe',
    //   name: '工程师'
    // },
    // {
    //   id: 'pe_gl',
    //   name: '工程师组长'
    // },
    // {
    //   id: 'pe_m',
    //   name: '工程师主管'
    // },
    {
      id: 'product',
      name: '产品'
    },
    {
      id: 'qa',
      name: '测试'
    },
    {
      id: 'dev',
      name: '开发'
    },
    {
      id: 'tg',
      name: '推广'
    },
    {
      id: 'bj',
      name: '编辑'
    },
    {
      id: 'sjs',
      name: '设计师'
    }
  ]
}

export default {
  ...constant,
  subRefundTypeMap: {
    '14': constant.handleTypeMap,
  },
}



// WEBPACK FOOTER //
// ./src/assets/js/Constant.js